import { useFieldContext } from "@/features/question/components/organisms/FieldRenderer";
import { useEffect, useMemo, useState } from "react";
import Combobox from "@/components/custom/Combobox";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
export function PickListRenderer() {
    const { question, setFormValue, disabled, response, currentValue } = useFieldContext();
    const [value, setValue] = useState<string>("");

    const options = useMemo(
        () => (question?.field_options as string[])?.map(option => option.trim()),
        [question?.field_options]
    );

    const items = useMemo(
        () => options?.map(option => ({ label: option, value: option })) ?? [],
        [options]
    );

    useEffect(() => {
        if(currentValue) {
            setValue(currentValue);
        }
    }, [currentValue]);

    useEffect(() => {
        if (!disabled && setFormValue) {
            setFormValue(value);
        }
    }, [setFormValue, value, disabled]);

    return (
        <div className="flex flex-col gap-2">
            {!disabled && (
                <Combobox
                    inDialog
                    triggerLabel={"Select a value"}
                    mode="single"
                    selectedValue={value ?? ""}
                    setSelectedValue={setValue}
                    items={items}
                    disabled={disabled}
                />
            )}


            {disabled && (
                <div className="flex flex-wrap gap-2">
                    {options?.map((option, index) => (
                        <div
                            key={index}
                            className={cn(`flex justify-center items-center rounded-full px-3 py-1 text-xs border min-w-[50px]`,
                                !disabled ? value.includes(option) : response?.field_value?.includes(option) ? "bg-green-200 border-green-300" : "bg-gray-200 border-gray-300"
                            )}
                        >
                            {option}
                            {!disabled ? value.includes(option) : response?.field_value?.includes(option) && <Check size="16" className="text-green-700 ms-1" />}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}